import './Footer.css'
function Footer()
{
    return (
        <div className='mt-10 xl:mt-14  flex flex-col justify-end'>
        <footer >
            <div className="container-fluid mt-md-5 mt-2">
                <div className="row">
                    <div className="col-12 text-center">
                    <a href='https://github.com/Batty-sk'>
                    <i class="bi bi-github"></i> 
                    </a>
                   <a href='https://www.linkedin.com/in/saurav-kumar-5225a2292/'><i class="bi bi-linkedin"></i>
                   </a>
                        <p>$K Artworks.</p>
                        <p>saorav.skumar@gmail.com</p>

                    </div>
                </div>
            </div>
        </footer>
        </div>
    )
}

export default Footer